module.exports = (__webpack_require__(831))(976710);